import { AddOutsourcedAgencyComponent } from './pages/add-outsourced-agency/add-outsourced-agency.component';
import { OutsourcedAgencyComponent } from './pages/outsourced-agency/outsourced-agency.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './services/authguard.service';
import { LeftSidebarComponent } from './layout-blueprints/left-sidebar/left-sidebar.component';
import { DashboardNewComponent } from './pages/dashboard-new/dashboard-new.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { LoginComponent } from './pages/login/login.component';
import { MinimalLayoutComponent } from './layout-blueprints/minimal-layout/minimal-layout.component';
import { ForgotPasswordNewComponent } from './pages/forgot-password-new/forgot-password-new.component';
import { EmployeesNewComponent } from './pages/employees-new/employees-new.component';
import { AddEmployeeComponent } from './pages/add-employee/add-employee.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { AgentReportsComponent } from './pages/agent-reports/agent-reports.component';
import { VersionComponent } from './pages/version/version.component';
import { ContractsComponent } from './pages/contracts/contracts.component';
import { PromoServicesComponent } from './pages/promo-services/promo-services.component';
import { AddContractServiceComponent } from './pages/add-contract-service/add-contract-service.component';
import { AddPromoServiceComponent } from './pages/add-promo-service/add-promo-service.component';
import { AddAdminComponent } from './pages/add-admin/add-admin.component';
import { ArDashboardComponent } from './pages/ar-dashboard/ar-dashboard.component';
import { CustomerDashboardComponent } from './pages/customer-dashboard/customer-dashboard.component'
import { ArLinkUnComponent } from './pages/ar-link-un/ar-link-un.component';
import { ArLinkInprogressComponent } from './pages/ar-link-inprogress/ar-link-inprogress.component';
import { ArInvoiceComponent } from './pages/ar-invoice/ar-invoice.component';
import { AddCustomerServiceComponent } from './pages/add-customer-service/add-customer-service.component';
import { CustomersComponent } from './pages/customers/customers.component';
import { AgenciesComponent } from './pages/agencies/agencies.component';
import { AddAgencyServiceComponent } from './pages/add-agency-service/add-agency-service.component';
import { TaxComponent } from './pages/tax/tax.component';
import { AddTaxServiceComponent } from './pages/add-tax-service/add-tax-service.component';
import { ArChartsComponent } from './pages/ar-charts/ar-charts.component';
import { ArReportsComponent } from './pages/ar-reports/ar-reports.component';
import { StationsComponent } from './pages/stations/stations.component';
import { AddStationComponent } from './pages/add-station/add-station.component';
import { AirlinesComponent } from './pages/airlines/airlines.component';
import { AddAirlinesComponent } from './pages/add-airlines/add-airlines.component';
import { ArCustomerTransactionComponent } from './pages/ar-customer-transaction/ar-customer-transaction.component';
import { ArCustomerInvoiceComponent } from './pages/ar-customer-invoice/ar-customer-invoice.component';
import { CustomerChartsDashboardComponent } from './pages/customer-charts-dashboard/customer-charts-dashboard.component';
import { AddContractsComponent } from './pages/add-contracts/add-contracts.component';
import { ReservationReportsComponent } from './pages/reservation-reports/reservation-reports.component';
import { SettingHomeComponent } from './pages/setting-home/setting-home.component'
import { MonthlyInvoiceReportsComponent } from "./pages/monthly-invoice-reports/monthly-invoice-reports.component";

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home', canActivate: [AuthGuard] },
  {
    path: '',
    component: MinimalLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent },
    ]
  },
  {
    path: 'home',
    component: LeftSidebarComponent, canActivate: [AuthGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'dashboard', component: DashboardNewComponent },
      { path: 'greets', loadChildren: () => import('./pages/greets/greets.module').then(m => m.GreetsModule) },
      { path: 'settings', component: SettingsComponent },
      { path: 'employees', component: EmployeesNewComponent },
      { path: 'add-employee', component: AddEmployeeComponent },
      { path: 'edit-employee/:id', component: AddEmployeeComponent },
      { path: 'bookings', loadChildren: () => import('./pages/bookings-new/bookings.module').then(m => m.BookingsModule) },
      { path: 'greet-request', component: NotificationsComponent },
      { path: 'reports', component: AgentReportsComponent },
      { path: 'reports/canceled-reservations', component: ReservationReportsComponent },
      { path: 'reports/monthly-invoice-reports', component: MonthlyInvoiceReportsComponent },
      { path: 'version', component: VersionComponent },
      { path: 'contracts', component: ContractsComponent },
      { path: 'promo-services', component: PromoServicesComponent },
      { path: 'add-contract-service', component: AddContractServiceComponent },
      { path: 'add-contracts', component: AddContractsComponent },
      { path: 'edit-contract-service/:cid/:sid', component: AddContractServiceComponent },
      { path: 'add-promo-service', component: AddPromoServiceComponent },
      { path: 'edit-promo-service/:cid/:sid', component: AddPromoServiceComponent },
      { path: 'add-admin', component: AddAdminComponent },
      { path: 'edit-admin/:id', component: AddAdminComponent },
      { path: 'ar-dashboard', component: ArDashboardComponent },
      { path: 'customer-dashboard', component: CustomerDashboardComponent },
      { path: 'ar-link-un/:id/:tid', component: ArLinkUnComponent },
      { path: 'ar-link-inprogress/:id/:tid', component: ArLinkInprogressComponent },
      { path: 'ar-invoice/:id/:tid', component: ArInvoiceComponent },
      { path: 'add-customer-service', component: AddCustomerServiceComponent },
      { path: 'agencies', component: AgenciesComponent },
      { path: 'add-agency-service', component: AddAgencyServiceComponent },
      { path: 'edit-agency-service/:agencyId', component: AddAgencyServiceComponent },
      { path: 'tax', component: TaxComponent },
      { path: 'add-tax-service', component: AddTaxServiceComponent },
      { path: 'edit-tax-service/:taxId', component: AddTaxServiceComponent },
      { path: 'customers', component: CustomersComponent },
      { path: 'add-customer-service', component: AddCustomerServiceComponent },
      { path: 'edit-customer-service/:customerId', component: AddCustomerServiceComponent },
      { path: 'ar-dashboard-charts', component: ArChartsComponent },
      { path: 'customer-charts-dashboard', component: CustomerChartsDashboardComponent },
      { path: 'ar-reports', component: ArReportsComponent },
      { path: 'stations', component: StationsComponent },
      { path: 'add-station', component: AddStationComponent },
      { path: 'edit-station/:id', component: AddStationComponent },
      { path: 'airlines', component: AirlinesComponent },
      { path: 'add-airlines', component: AddAirlinesComponent },
      { path: 'outsourceAgency', component: OutsourcedAgencyComponent },
      { path: 'add-outsourceAgency', component: AddOutsourcedAgencyComponent },
      { path: 'edit-outsourceAgency/:id', component: AddOutsourcedAgencyComponent },
      { path: 'ar-customer-transaction/:id/:tid', component: ArCustomerTransactionComponent },
      { path: 'ar-customer-invoice/:id/:tid', component: ArCustomerInvoiceComponent },
      { path: 'setting-home', component: SettingHomeComponent },
    ]
  },
  { path: 'forgot-password', component: ForgotPasswordNewComponent },
  { path: '**', redirectTo: '' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      useHash: true
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
